import { render, staticRenderFns } from "./appletConfig.vue?vue&type=template&id=18dd9178&scoped=true&"
import script from "./appletConfig.vue?vue&type=script&lang=js&"
export * from "./appletConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dd9178",
  null
  
)

export default component.exports